module.exports = __webpack_public_path__ + "static/monika-54f3475095603e40f3a84c7ce8a3c362.png";